<template>
	<section class="content">
		<div class="row">
			<div class="col-md-12">
				<div class="box box-primary">
					<div class="box-header with-border">
						<h3 class="box-title">
							<b>Escalas</b>
						</h3>
					</div>
					<div class="box-body">
						<div class="row">
							<div class="col-md-6">
								<div class="form-group">
									<label for="">Unidade</label>
									<select-unidade :tipo="TIPO_CONTRATO.PRESTADOR" @setUnidadeSelecionada="(unidadeSelecionada)=>{setUnidadeSelecionada(unidadeSelecionada)}"></select-unidade>
								</div>
							</div>
							<div class="col-md-6">
								<div class="form-group">
									<label for="">Profissional</label>
									<select-profissional @setProfissionalSelecionado="(profissionalSelecionado)=>{setProfissionalSelecionado(profissionalSelecionado)}"></select-profissional>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-6">
								<div class="form-group">
									<label for="">Procedimento</label>
									<select-procedimento @setProcedimentoSelecionado="(procedimentoSelecionado)=>{setProcedimentoSelecionado(procedimentoSelecionado)}"></select-procedimento>
								</div>
							</div>
							<div class="col-md-6">
								<div class="form-group">
									<label for="">Situação</label>
									<select class='form-control' name='situacao' v-model="filtros.situacao">
	                    <option :value="null">Todas</option>
	                    <option :value="SITUACAO.ATIVA">Ativas</option>
	                    <option :value="SITUACAO.INATIVA">Inativas</option>
	                  </select>
								</div>
							</div>
						</div>
						<div class="box-footer text-right" ref='filtrar'>
							<button class="btn btn-info" :disabled="finalizado" @click.self.prevent="getPDF" v-if="pdf">Recarregar PDF <span
	                  class="fa fa-file-pdf-o"
	                  aria-hidden="true"
	                ></span></button>
							<button @click="getDataTable()" data-toggle="tooltip" title="Pesquisar Relatório de Escalas por Unidade" class="btn btn-primary" :disabled="finalizado"><span class="fa fa-search"></span> Pesquisar</button>
						</div>
						<div v-if="pdf">
							<embed type='application/pdf' :src="pdf" width='100%' :height="heigthPdf" />
						</div>
						<div class="row" style="margin-top:15px" v-else>
							<div class="col-md-12">
								<div class="table-responsive form-group">
									<table role="grid" class="table table-bordered" v-for="(unidade, index) in dataTable.data" :key="index">
										<thead>
											<tr role="row">
												<th>Unidade: {{unidade.nome}}</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td v-if="unidade.profissionais && unidade.profissionais.length == 0">
													<h4>Nenhum profissional encontrado!</h4>
												</td>
											</tr>
											<tr class="even" role="row" v-for="(profissional, index) in unidade.profissionais" :key="index">
												<td>
													<table role="grid" class="table table-bordered table-striped">
														<thead>
															<tr role="row">
																<th colspan="5">Profissional: {{profissional.nome}}
																</th>
															</tr>
															<tr role="row">
																<th>Agenda</th>
																<th>Dia</th>
																<th>Horário</th>
																<th>Quantidade</th>
																<th>Retorno</th>
															</tr>
														</thead>
														<tbody>
															<tr>
																<td v-if="profissional.contrato_procedimento_atendimentos && profissional.contrato_procedimento_atendimentos.length == 0" colspan="5">
																	<h4>Nenhum procedimento encontrado!</h4>
																</td>
															</tr>
															<tr class="even" role="row" v-for="(agenda, index) in profissional.contrato_procedimento_atendimentos" :key="index">
																<td style="width: 60%">{{agenda.contrato_procedimento.procedimento.codigo}} - {{agenda.contrato_procedimento.procedimento.nome}}</td>
																<td style="width: 5%">{{agenda.dia | dia}}</td>
																<td style="width: 15%">{{agenda.hora_inicial}} às {{agenda.hora_final}}</td>
																<td style="width: 10%">{{agenda.quantidade_primeira}}</td>
																<td style="width: 10%">{{agenda.quantidade_retorno}}</td>
															</tr>
														</tbody>
													</table>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								<div class="row" v-if="dataTable.data && dataTable.data.length > 0">
									<div class="col-sm-4">
										Mostrando {{ this.dataTable.from }} até {{ this.dataTable.to }} de {{ this.dataTable.total }} registros encontrados.
									</div>
									<div class="col-sm-6" style="text-align:right">
										<laravue-pagination :data="dataTable" v-on:pagination-change-page="getDataTable">
											<span slot="prev-nav">&lt; Anterior</span>
											<span slot="next-nav">Próximo &gt;</span>
										</laravue-pagination>
									</div>
									<div class="col-sm-2 text-right">
										<button class="btn btn-info pdf" :disabled="finalizado" @click.self.prevent="getPDF"><span class="fa fa-file-pdf-o" aria-hidden="true"></span> PDF</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import selectUnidade from "@/components/cadastros/unidades/selectUnidade";
import selectProfissional from "@/components/cadastros/profissionais/selectProfissional";
import selectProcedimento from "@/components/cadastros/procedimentos/selectProcedimento";
import {
	SITUACAO,
	TIPO_CONTRATO
} from "@/constants";
import axios from 'axios' // Cliente para requisição http

export default {
	computed: {
		SITUACAO: function() {
			return SITUACAO;
		},
		TIPO_CONTRATO: function() {
			return TIPO_CONTRATO;
		}
	},
	data: () => ({
		pdf: null,
		heigthPdf: 900,
		finalizado: false,
		filtros: {
			unidade_id: null,
			unidade: '',
			profissional_id: null,
			profissional: '',
			procedimento_id: null,
			procedimento: '',
			situacao: null,
		},
		dataTable: {},
	}),
	mounted() {

	},

	methods: {
		sortByKey: function(field) {
			this.filtros.coluna = field;
			if (this.filtros.ordem == 'asc') {
				this.filtros.ordem = 'desc';
			} else {
				this.filtros.ordem = 'asc';
			}
			// this.getUsers();
		},
		getDataTable(page) {
			this.finalizado = true;
			this.pdf = null;
			if (typeof page === 'undefined') {
				page = 1;
			}
			this.filtros.page = page;
			this.$store.commit('TOGGLE_LOADING');
			let config = this.$store.getters.getHeaderAuth;
			config.params = this.filtros;

			axios.get(`${this.$store.state.serverURI}/api/relatorios/escalas`, config)
				.then(response => {
					this.dataTable = response.data;
					this.$store.commit('TOGGLE_LOADING');
					this.finalizado = false;
				}).catch((error) => {
					this.$store.commit('throwException', error);
					this.finalizado = false;
				});
		},
		getPDF() {
			this.finalizado = true;
			this.$store.commit('TOGGLE_LOADING');
			let config = this.$store.getters.getHeaderAuthFile;
			config.params = this.filtros;
			axios.get(`${this.$store.state.serverURI}/api/relatorios/escalasImprimir`, config)
				.then(response => {
					this.$store.commit('TOGGLE_LOADING');
					const file = new Blob([response.data], { type: 'application/pdf' });
					const fileURL = window.URL.createObjectURL(file);
					this.pdf = fileURL;
					let self = this;
					this.heigthPdf = window.innerHeight - 65;
					console.log(window.innerHeight)
					setTimeout(function() {
						self.$refs.filtrar.scrollIntoView();
					}, 300);
					this.finalizado = false;
				}).catch((error) => {
					this.$store.commit('throwException', error);
					this.finalizado = false;
				});
		},
		setUnidadeSelecionada(unidadeSelecionada) {
			this.filtros.unidade = unidadeSelecionada.nome
			this.filtros.unidade_id = unidadeSelecionada.id
		},
		setProfissionalSelecionado(profissionalSelecionado) {
			this.filtros.profissional = profissionalSelecionado.nome
			this.filtros.profissional_id = profissionalSelecionado.id
		},
		setProcedimentoSelecionado(procedimentoSelecionado) {
			this.filtros.procedimento = procedimentoSelecionado.nome
			this.filtros.procedimento_id = procedimentoSelecionado.id
		},
	},
	watch: {
		page: function(val) {
			this.getDataTable();
		}
	},

	components: {
		selectUnidade,
		selectProfissional,
		selectProcedimento,
	}

}
</script>

<style scoped>
.pdf {
	margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// index.vue?1e52cb83